import React from 'react'
import PropTypes from 'prop-types'

const ClonedLeagueLink = ({label, path}) => {
  return <a href={path} target="_blank" className={path ? 'cloned-league-link' : 'cloned-league-text'}>
    {label}
  </a>
}

ClonedLeagueLink.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
}

export default ClonedLeagueLink
